import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { faVolumeUp, faGamepad } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

const InfoActivitiesHeader = ({ activity, setOpenState, onCloseModal
}) => {
  // Função para fechar o modal
  const handleClose = () => {
    setOpenState(false);
    if (onCloseModal) {
      onCloseModal()
    }
  };

  // Mapeamento dos ícones com base no tipo de atividade
  const activityIcons = {
    Game: faGamepad,
    Audio: faVolumeUp,
  };

  //?Obter o ícone com base no tipo
  const getActivityIcon = (type) => activityIcons[type] || null;

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1380px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "12px",
        borderRadius: "12px",
        color: "#662d91",
        fontSize: "20px",
        fontWeight: "600",
        lineHeight: "30px",
        position: "relative",

        // Responsividade para telas menores
        "@media (max-width: 720px)": {
          fontSize: "16px",
          padding: "8px",
          justifyContent: "center",
          textAlign: "center",
        },
      }}
    >
      {/* Nome da atividade com o ícone correspondente */}
      <Typography
        data-testid="modalInfoActivities_activityName_text"
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "center",
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "hidden",
          marginRight: "30px",
          marginLeft: "28px",
          marginTop: "10px",

          "@media (max-width: 720px)": {
            fontSize: "14px",
            margin: "5px 10px",
            maxWidth: "calc(100% - 50px)",
            textAlign: "center",
          },
        }}
      >
        {activity.name}
      </Typography>

      {getActivityIcon(activity.type) && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
            width: "103px",
            height: "36px",
            background: " #D8CEE0",
            borderRadius: "30px",

            "@media (max-width: 720px)": {
              width: "80px",
              height: "30px",
            },
          }}
        >
          {/* Ícone da atividade */}
          <FontAwesomeIcon
            icon={getActivityIcon(activity.type)}
            style={{ fontSize: "24px" }}
          />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "16px",
              lineHeight: "30px",

              "@media (max-width: 720px)": {
                fontSize: "12px",
              },
            }}
          >
            {activity.type === "Game" && " Jogo"}
            {activity.type === "Audio" && "Áudio"}
          </Typography>
        </Box>
      )}

      {/* Botão de fechar o modal */}
      <Box
        sx={{
          position: "absolute",
          top: "12px",
          right: "12px",
          zIndex: 1000,

          "@media (max-width: 720px)": {
            top: "8px",
            right: "8px",
          },
        }}
      >
        <IconButton data-testid="modalInfoActivities_close_btn" onClick={handleClose} sx={{ p: 0 }}>
          <CancelOutlinedIcon color="primary" sx={{ fontSize: 40 }} />
        </IconButton>
        {/* <IconButton
          onClick={handleClose}
          sx={{
            width: "37px",
            height: "37px",
            fill: "#FFF",
            strokeWidth: "2px",
            color: "#662D91",
            border: "solid 1px #662D91",

            "@media (max-width: 720px)": {
              width: "30px",
              height: "30px",
            },
          }}
        >
          X
        </IconButton> */}
      </Box>
    </Box>
  );
};

export default InfoActivitiesHeader;
